// extracted by mini-css-extract-plugin
export default {"iconDefault":"Goal_iconDefault__NWPVu"};